import React, { useContext, useEffect, useRef, useState } from 'react';
import { ChatbotContext } from '../contexts/ChatbotContext';
import { FullTranscriptModal } from './FullTranscriptModal';
import { Source } from '../types';
import { SessionContext } from '../contexts/SessionContext';
import { APIContext } from '../contexts/APIContext';

export const EventDelegationComponent = (props: any) => {
  const { sourceHistory, highScore, showCancelButton } = useContext(ChatbotContext);
  const { isPromptGenerating } = useContext(SessionContext);
  const [showFullTranscript, setShowFullTranscript] = useState(false);
  const [currentTranscript, setCurrentTranscript] = useState('');
  const [currentCitation, setCurrentCitation] = useState('');
  const [currentInterviewDate, setCurrentInterviewDate] = useState('');
  const [currentSorce, setCurrentSorce] = useState<string | undefined>('');
  const [overlayStyles, setOverlayStyles] = useState({
    overLayTop: 0,
    overLayBottom: 0,
    overLayLeft: 0,
    overLayRight: 0,
  });
  const { chatResponse, matchingScore, setMatchingScore } = useContext(APIContext);
  const parsedResponse: any =
    typeof chatResponse === 'object' && (chatResponse as any)?.stepResponse ? chatResponse : undefined;
  const previousTopRef = useRef<number | null>(null);

  const setOverLayPosition = (currentElement: HTMLElement) => {
    setOverlayStyles({
      overLayTop: currentElement?.getBoundingClientRect().top - 10,
      overLayBottom: currentElement?.getBoundingClientRect().bottom + 10,
      overLayLeft: currentElement?.getBoundingClientRect().left - 10,
      overLayRight: currentElement?.getBoundingClientRect().right + 10,
    });
  };

  useEffect(() => {
    let timer: any;
    if (showCancelButton) {
      const currentElement = document.querySelector('#stop-response-container') as HTMLElement;
      if (currentElement) {
        const currentTop = currentElement.getBoundingClientRect().top;
        if (previousTopRef.current !== currentTop) {
          previousTopRef.current = currentTop;
          setOverLayPosition(currentElement);
        }

        if (
          parsedResponse?.stepResponse?.currentStep ===
          'Fetch Response from Generate Insights powered by GenAI on Console'
        ) {
          timer = setTimeout(() => {
            setOverLayPosition(currentElement);
          }, 4000);
        }
      }
    }
    return () => {
      clearTimeout(timer);
    };
  });

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const transcriptId = (e.target as HTMLDivElement).dataset.transcriptid;
    if (transcriptId) {
      // const citationId: string = (e.target as HTMLDivElement).dataset.citationidfrombutton ?? '';
      // console.log('Selected Citation', citationId);
      const matchedSource: Source | undefined = (() => {
        for (const source of Object.values(sourceHistory)) {
          const sourceList = source.sourceList;
          const matched = sourceList.find((source) => source.id === transcriptId);
          if (matched) return matched;
        }
      })();
      if (matchedSource) {
        setShowFullTranscript(true);
        setCurrentTranscript(matchedSource.transcript);
        setCurrentCitation(matchedSource.citation);
        setCurrentInterviewDate(matchedSource?.interview_date || '');
        setCurrentSorce(matchedSource.source);
        setMatchingScore(matchedSource.score.toFixed(2));
        // setCurrentCitationId(citationId);
      }
    }
  };

  /* Highlight based on matching citation id */
  // useEffect(() => {
  //   if (showFullTranscript === true) {
  //     setTimeout(() => {
  //       const marks = document.querySelectorAll(`mark:not([data-citationid="${currentCitationId}"])`);
  //       marks.forEach((mark) => {
  //         (mark as HTMLMapElement).dataset.highlight = 'false';
  //       });
  //     }, 0);
  //   } else {
  //     const marks = document.querySelectorAll('mark');
  //     marks.forEach((mark) => {
  //       mark.dataset.highlight = 'true';
  //     });
  //   }
  // }, [showFullTranscript]);

  return (
    <>
      <FullTranscriptModal
        showFullTranscript={showFullTranscript}
        setShowFullTranscript={setShowFullTranscript}
        currentCitation={currentCitation}
        currentInterviewDate={currentInterviewDate}
        currentTranscript={currentTranscript}
        currentSorce={currentSorce}
        matchingScore={matchingScore}
      />
      {isPromptGenerating && (
        <>
          <div
            className={`fixed top-0 left-0 w-full z-10`}
            style={{
              height: `${
                document.querySelector('#stop-response-container') ? overlayStyles.overLayTop + 'px' : '100vh'
              }`,
            }}
          ></div>
          <div
            className={`fixed left-0 bottom-0 w-full z-10`}
            style={{ height: `calc(100vh - ${overlayStyles.overLayBottom}px)` }}
          ></div>
          <div className={`fixed top-0 left-0 h-full z-10`} style={{ width: `${overlayStyles.overLayLeft}px` }}></div>
          <div
            className={`fixed top-0 right-0 h-full z-10`}
            style={{ width: `calc(100vw - ${overlayStyles.overLayRight}px)` }}
          ></div>
        </>
      )}
      <div onClick={handleClick}>{props.children}</div>
    </>
  );
};
